var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('v-checkbox',_vm._g(_vm._b({},'v-checkbox',_vm.$props,false),_vm.checkboxListeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }